const isEnabled = () => process.env.REACT_APP_SENTRY_ENABLED !== 'false'

const sentry = { isEnabled }
export default sentry
